import { IonAvatar, IonIcon, IonItem, IonLabel, IonList } from "@ionic/react";
import { fileTrayOutline } from "ionicons/icons";
import React from "react";

interface Attachment {
  name: string;
  size: string;
  thumbnail: string;
  url: string;
}

export const Attachments = (props: any) => {
  const [showThumbnail, setShowThumbnail] = React.useState(true);

  return (
    <IonList
      inset={true}
      style={{
        marginInline: 0,
      }}
    >
      {props.attachments?.map((attachment: Attachment) => (
        <IonItem
          button
          href={attachment.url}
          target={"_blank"}
          key={attachment.url}
          style={{
            "--padding-start": 0,
          }}
        >
          <IonAvatar
            slot={"start"}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {attachment.thumbnail && showThumbnail ? (
              <img
                alt={attachment.name}
                src={attachment.thumbnail}
                onError={() => {
                  setShowThumbnail(false);
                }}
              />
            ) : (
              <IonIcon icon={fileTrayOutline} />
            )}
          </IonAvatar>
          <IonLabel>{attachment.name}</IonLabel>
          <IonLabel slot={"end"}>{attachment.size}</IonLabel>
        </IonItem>
      ))}
    </IonList>
  );
};
